import { gql } from '@apollo/client'

// returns array of bookings
export const GET_USER_BOOKINGS = gql`
    query get_user_bookings {
        get_user_bookings {
            start_date
            price
            plates {
                plate
            }
            payment_method
            lot_name
            lot_id
            lot_address
            end_date
            email
            created_at_iso_str
            invoices {
                invoice_id
            }
            booking_ref
            booking_type
            night_parking_data {
                iso_duration
                rrule
            }
        }
    }
`
